module.exports = __webpack_public_path__ + "static/media/new-star-filled.b715fd28.png";